import ProductFruitsProvider from "./ProductFruitsProvider";

export default ProductFruitsProvider;
